/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/require-default-props */
import React, { useEffect, useMemo } from 'react'
import { Wrapper, FloatInput, FloatLabel } from './FloatLabelInput.styles'

interface IFloatInputProps {
    onChange?: (value: undefined | string) => void
    labelText?: string
    type?: string
    border?: string
    value?: string
    disabled?: boolean
}

const FloatLabelInput: React.FC<IFloatInputProps> = ({
    onChange,
    labelText,
    type,
    border,
    disabled,
    value,
}): JSX.Element => {
    const [focus, setFocus] = React.useState(false)
    const inputRef = React.useRef<HTMLInputElement>(null)
    const handleFocus = () => {
        setFocus(true)
        if (inputRef.current !== null) {
            inputRef.current.focus()
        }
    }
    const handleBlur = () => {
        if (inputRef.current) {
            setFocus(!!inputRef.current.value)
        }
    }
    const handleChange = (event: any) => {
        const { value: inputValue } = event.target
        if (!focus && value) setFocus(true)
        if (onChange) onChange(inputValue)
    }

    useEffect(() => {
        if (inputRef.current) {
            setFocus(!!inputRef.current.value)
        }
    }, [inputRef.current])

    const passwordValue = useMemo(() => {
        if (type === 'password') {
            if (disabled) return 'sample password'
            if (value === undefined) return ''
        }
        return value
    }, [disabled, type, value])
    return (
        <Wrapper disabled={disabled} focus={focus}>
            <FloatInput
                ref={inputRef}
                onBlur={handleBlur}
                onFocus={handleFocus}
                onChange={handleChange}
                type={type}
                border={border}
                disabled={disabled}
                value={passwordValue}
            />
            <FloatLabel disabled={disabled} onClick={handleFocus} focus={focus}>
                {labelText}
            </FloatLabel>
        </Wrapper>
    )
}

export default FloatLabelInput
